import React from "react";
import { useSelector } from "react-redux";
import { FooterIconButton, IconButton } from "../../base/buttons";
import { getGroupId, getMainRoomRole } from "../../base/conference";
import { translate } from "../../base/i18n";
import { ROLE } from "../../base/participants";
import { connect } from "../../base/redux";
import { GROUP_MODAL_ID } from "../../options";
import { setGroupPanel } from "../action";

function SwitchGroupButton({
    t, dispatch, 
    isOption, mainRole, status, panel, currentGroupId 
}) {
    if (currentGroupId !== "") return null;
    if ([ROLE.HOST, ROLE.MANAGER].indexOf(mainRole) === -1) return null;
    const checked = useSelector(state => state['features/base/modal'].name === GROUP_MODAL_ID);
    
    const onClick = () => {
        if (status) {
            dispatch(setGroupPanel(!panel));
        } else {
            APP.UI.openModal(GROUP_MODAL_ID);
        }        
    }

    return (
        <>
            { isOption ? 
                <> {APP.layout.option.group && <IconButton clsName={`button button_${panel ? 'on': 'off'}`} mode="group" name={t("options.group")} size={22} onClick={onClick} />}</>
                : <> {APP.layout.footer.group && <FooterIconButton checked={panel} mode="group" name={t("options.group")} width={43} height={43} onClick={onClick} />} </> 
            }
        </>
    )
}

function _mapStateToProps(state) {
    const mainRole = getMainRoomRole(state);
    const currentGroupId = getGroupId(state);
    const { panel, status } = state["features/group"];

    return  {
        currentGroupId,
        mainRole,
        panel, 
        status
    }
}

export default translate(connect(_mapStateToProps)(SwitchGroupButton));